import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../client/components/ui/select";
import useTranslation from "../../client/hooks/useTranslation";

export default function TopbarStatusFilterWidget({
  value,
  onChange,
}: {
  value: "all" | "open" | "closed";
  onChange: (v: "all" | "open" | "closed") => void;
}) {
  const t = useTranslation();
  return (
    <Select value={value} onValueChange={(v) => onChange(v as "all" | "open" | "closed")}>
      <SelectTrigger className="h-9 w-[130px] text-sm">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">{t.journal.statusAll}</SelectItem>
        <SelectItem value="open">{t.journal.statusOpen}</SelectItem>
        <SelectItem value="closed">{t.journal.statusClosed}</SelectItem>
      </SelectContent>
    </Select>
  );
}
